var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';
 let { tradeoff, key, property } = options; 
__p+='\n\n<div class="consider-property">\n  <div class="js-tracking" data-propertyid="'+
((__t=( tradeoff.property_id ))==null?'':__t)+
'" data-listingid="'+
((__t=( tradeoff.listing_id ))==null?'':__t)+
'" data-status="'+
((__t=( tradeoff.status ))==null?'':__t)+
'" data-url="/realestateandhomes-detail/'+
((__t=( tradeoff.href ))==null?'':__t)+
'">\n    <a href="'+
((__t=( tradeoff.href ))==null?'':__t)+
'" target="_blank" data-omtag="ldp:browse-more:similar-homes:tradeoff:'+
((__t=( key.replace(/_/g, '-') ))==null?'':__t)+
'">\n      ';
 if (tradeoff.primary_photo.href) { 
__p+='\n        <img src="'+
((__t=( tradeoff.primary_photo.href ))==null?'':__t)+
'" alt="'+
((__t=( tradeoff.location.address.line ))==null?'':__t)+
'">\n      ';
 } else { 
__p+='\n        <div class="coming-soon-img"></div>\n      ';
 } 
__p+='\n      <div class="consider-property-details">\n        <div class="price">\n          '+
((__t=( tradeoff.additional_info.price_display ))==null?'':__t)+
'\n        </div>\n        <div class="property-meta">\n          '+
((__t=( tradeoff.additional_info.beds_display ))==null?'':__t)+
',\n          '+
((__t=( tradeoff.additional_info.baths_display ))==null?'':__t)+
',\n          '+
((__t=( tradeoff.additional_info.sqft_display ))==null?'':__t)+
'\n        </div>\n      </div>\n    </a>\n  </div>\n  <div>\n    <ul class="comparable-property-comparison list-unstyled">\n      ';

        let year_built = tradeoff.description.year_built,
            sqft       = tradeoff.description.sqft,
            price      = tradeoff.list_price;
      
__p+='\n      ';
 if (key === 'newer_homes' && tradeoff.additional_info.compared_year_built) { 
__p+='\n        <li class="';
 if (property.year_built === year_built) { 
__p+='even';
 } else if (property.year_built < year_built) { 
__p+='arrow-up';
 } else if (property.year_built > year_built) { 
__p+='arrow-down';
 } 
__p+='">\n          '+
((__t=( tradeoff.additional_info.compared_year_built ))==null?'':__t)+
'\n        </li>\n      ';
 } 
__p+='\n      ';
 if (key === 'lower_price' && tradeoff.additional_info.compared_sqft) { 
__p+='\n        <li class="';
 if (property.sqft === sqft) { 
__p+='even';
 } else if (property.sqft < sqft) { 
__p+='arrow-up';
 } else if (property.sqft > sqft) { 
__p+='arrow-down';
 } 
__p+='">\n          '+
((__t=( tradeoff.additional_info.compared_sqft ))==null?'':__t)+
'\n        </li>\n      ';
 } 
__p+='\n      ';
 if (tradeoff.additional_info.compared_price) { 
__p+='\n        <li class="';
 if (property.price === price || tradeoff.additional_info.compared_price.includes('Similar')) { 
__p+='even';
 } else if (property.price < price) { 
__p+='arrow-up';
 } else if (property.price > price) { 
__p+='arrow-down';
 } 
__p+='">\n          '+
((__t=( tradeoff.additional_info.compared_price ))==null?'':__t)+
'\n        </li>\n      ';
 } 
__p+='\n      ';
 if (key === 'larger_homes' && tradeoff.additional_info.compared_sqft) { 
__p+='\n        <li class="';
 if (property.sqft === sqft) { 
__p+='even';
 } else if (property.sqft < sqft) { 
__p+='arrow-up';
 } else if (property.sqft > sqft) { 
__p+='arrow-down';
 } 
__p+='">\n          '+
((__t=( tradeoff.additional_info.compared_sqft ))==null?'':__t)+
'\n        </li>\n      ';
 } 
__p+='\n    </ul>\n  </div>\n</div>\n';
return __p;
};



// WEBPACK FOOTER //
// ./quick_view/templates/consider-home/browse-module-card.jst.ejs